module.exports = __webpack_public_path__ + "static/media/funan_4.7b69c929.jpg";